import { InputAdornment as MuiInputAdornment, type InputAdornmentProps as MuiInputAdornmentProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiInputAdornmentProps, 'variant'>>;

export function InputAdornment(props: Props) {
  return <MuiInputAdornment {...props} />;
}

export type { Props as InputAdornmentProps };
